// alpine
import Alpine from "alpinejs";

// swiper
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Alpine = Alpine;

Alpine.store("showNavButton", true);
Alpine.store("availableSlide", {
    index: 2,
    increment() {
        this.index++;
    },
    setIndex(idx) {
        this.index = idx;
    },
});
Alpine.store("currentSlide", {
    index: 0,
    next() {
        this.index++;
    },
    prev() {
        this.index--;
    },
    setIndex(idx) {
        this.index = idx;
    },
});

Alpine.data("formItem", (...subItemValues) => ({
    isFocus: false,
    isSkip: false,
    subItems: [...subItemValues],
    subFormComplete: false,
    checkChange: {
        ["@change"]() {
            const checked = this.$el.querySelector(
                'input[type="checkbox"]'
            ).checked;
            if (checked && !this.isFocus) {
                focusItemAnim.open(this.$el);
                this.isFocus = true;
                this.isSkip = false;
                this.$store.showNavButton = false;
            } else if (!checked && this.isFocus) {
                focusItemAnim.close(this.$el);
                this.isFocus = false;
                this.$store.showNavButton = true;
            }
        },
    },
    skip: {
        ["@change"]() {
            const checkItem = this.$el
                .closest(".form_item")
                .querySelector(".check_wrap");
            if (this.$el.checked) {
                focusItemAnim.close(checkItem);
                this.isFocus = false;
                this.$store.showNavButton = true;
            }
        },
    },
    subFormDoneButton: {
        ":disabled"() {
            return !this.subFormComplete;
        },
        ["@click"]() {
            const checkItem = this.$el
                .closest(".form_item")
                .querySelector(".check_wrap");
            setTimeout(() => {
                focusItemAnim.close(checkItem);
                this.isFocus = false;
                this.$store.showNavButton = true;
            }, 400);
        },
    },
    q13_4_2: {
        ["@change"]() {
            if (this.$el.checked) {
                this.$refs.q13_4_1.value = 0;
                this.$refs.q13_4_1.setAttribute("disabled", true);
                this.$refs.q13_4_1
                    .closest(".input_with_unit")
                    .classList.add("disabled");
                this.subFormComplete = true;
            } else {
                this.$refs.q13_4_1.value = "";
                this.$refs.q13_4_1.removeAttribute("disabled");
                this.$refs.q13_4_1
                    .closest(".input_with_unit")
                    .classList.remove("disabled");
                this.subFormComplete = false;
            }
        },
    },
    init() {
        this.$watch("subItems", () => {
            this.subFormComplete = this.subItems.every(
                (item) => item != null && item != undefined
            );
        });
    },
}));

Alpine.start();

window.swiper = new Swiper(".main_swiper", {
    direction: "vertical",
    allowSlideNext: false,
    allowSlidePrev: false,
    allowTouchMove: false,
    preventClicks: false,
    preventClicksPropagation: false,
});

const subSwiper = new Swiper(".sub_swiper", {
    spaceBetween: 14,
    slidesPerView: 1.2,
    centeredSlides: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

swiper.on("slideChange", () => {
    Alpine.store("currentSlide").setIndex(swiper.activeIndex);
});

document.querySelector(".start_button").addEventListener("click", function () {
    swiper.allowSlideNext = true;
    setTimeout(() => {
        swiper.slideNext();
        document.querySelectorAll(".nav_button").forEach((el) => {
            el.classList.remove("d_none");
        });
    }, 400);
});

document.querySelectorAll(".nav_button").forEach((el) => {
    if (el.classList.contains("next_button")) {
        el.addEventListener("click", function () {
            setTimeout(() => {
                swiper.slideNext();
            }, 300);
        });
    }
    if (el.classList.contains("prev_button")) {
        el.addEventListener("click", function () {
            swiper.allowSlidePrev = true;
            setTimeout(() => {
                swiper.slidePrev();
                swiper.allowSlidePrev = false;
            }, 300);
        });
    }
});

document.querySelectorAll(".btn.next")?.forEach((btn) => {
    btn.addEventListener("click", () => {
        setTimeout(() => {
            swiper.slideNext();
        }, 400);
    });
});

document.querySelectorAll(".ripple")?.forEach((ripple) => {
    ripple.addEventListener("click", function (e) {
        this.querySelectorAll(".ripple_effect")?.forEach((el) => el.remove());
        this.insertAdjacentHTML(
            "afterbegin",
            `<span class="ripple_effect" style="left: ${e.offsetX}px;top: ${e.offsetY}px;"></span>`
        );
    });
});

document.querySelectorAll(".check_wrap").forEach((el) => {
    el.setAttribute("draggable", "true");
});

const focusItemAnim = {
    mvX: 0,
    mvY: 0,
    open: async function (checkItem) {
        const focusItemView = checkItem.closest(".form_item_view");
        const focusItem = checkItem.closest(".form_item");
        const subItem = focusItem.querySelector(".form_sub_item");
        const slide = checkItem.closest(".swiper-slide");
        const scrolled = slide?.scrollTop;
        if (scrolled) {
            slide.scrollTo({ top: 0, behavior: "smooth" });
        }
        // 移動位置を求める
        const intent = checkItem
            .closest(".form_item_view")
            .getBoundingClientRect();
        const coordinate = checkItem.getBoundingClientRect();
        this.mvX = coordinate.left - intent.left;
        this.mvY = coordinate.top - intent.top;

        // 他のチェックボックスのopacityを0にする
        focusItemView.querySelectorAll(".form_item")?.forEach((elm) => {
            if (elm.querySelector(".check_wrap") == checkItem) {
                return;
            }
            elm.style.opacity = 0;
        });
        slide.querySelector(".slide_navigation").style.opacity = 0;

        // プライマリカラーに変更
        checkItem.classList.add("text_primary");
        await Promise.all(
            checkItem.getAnimations()?.map((anim) => anim.finished)
        );
        focusItem.style.zIndex = "100";

        // 位置を変更
        if (this.mvY + this.mvX > 0) {
            focusItem.style.transform = `translate(-${this.mvX}px,-${this.mvY}px)`;
            await Promise.all(
                focusItem.getAnimations()?.map((anim) => anim.finished)
            );
        }

        // 下線を引く
        checkItem.classList.add("under_line_grow");
        await Promise.all(
            checkItem
                .getAnimations({ subtree: true })
                ?.map((anim) => anim.finished)
        );
        checkItem.classList.add("grown_under_line");
        checkItem.classList.remove("under_line_grow");

        // 詳細設問を展開
        subItem?.classList.add("expand");
        await Promise.all(subItem.getAnimations().map((anim) => anim.finished));
        subItem.classList.add("expanded");
        subItem.classList.remove("expand");

        // 他のチェックボックスを非表示にする
        focusItemView.querySelectorAll(".form_item")?.forEach((elm) => {
            if (elm.querySelector(".check_wrap") == checkItem) {
                return;
            }
            elm.style.display = "none";
        });
        slide.querySelector(".slide_navigation").style.display = "none";
        focusItem.style.transition = "none";
        focusItem.style.transform = "";
    },
    close: async function (checkItem) {
        console.log(this);
        const focusItemView = checkItem.closest(".form_item_view");
        const focusItem = checkItem.closest(".form_item");
        const subItem = focusItem.querySelector(".form_sub_item");
        const slide = checkItem.closest(".swiper-slide");
        const scrolled = slide?.scrollTop;
        if (scrolled) {
            slide.scrollTo({ top: 0, behavior: "smooth" });
        }
        // 他のチェックボックスを表示する
        focusItemView.querySelectorAll(".form_item")?.forEach((elm) => {
            if (elm.querySelector(".check_wrap") == checkItem) {
                return;
            }
            elm.style.display = "";
        });
        slide.querySelector(".slide_navigation").style.display = "";
        // 位置を変更
        if (this.mvY + this.mvX > 0) {
            focusItem.style.transform = `translate(-${this.mvX}px,-${this.mvY}px)`;
        }
        // 詳細設問を閉じる
        subItem?.classList.add("contract");
        await Promise.all(
            subItem.getAnimations()?.map((anim) => anim.finished)
        );
        subItem.classList.remove("expanded", "contract");

        // 下線を収縮してから削除
        checkItem.classList.add("shrink");
        await Promise.all(
            checkItem
                .getAnimations({ subtree: true })
                ?.map((anim) => anim.finished)
        );
        checkItem.classList.remove("grown_under_line", "shrink");

        // 位置を戻す
        focusItem.style.transition = "0.2s";
        focusItem.style.transform = "";
        await Promise.all(
            focusItem.getAnimations()?.map((anim) => anim.finished)
        );

        // 他のチェックボックスのopacityを0にする
        focusItemView.querySelectorAll(".form_item")?.forEach((elm) => {
            if (elm.querySelector(".check_wrap") == checkItem) {
                return;
            }
            elm.style.opacity = 1;
        });
        slide.querySelector(".slide_navigation").style.opacity = 1;

        focusItem.style.zIndex = "";
        checkItem.classList.remove("text_primary");
    },
};

window.onload = async () => {
    const wh = window.innerHeight;
    document.querySelectorAll(".swiper-slide")?.forEach((el) => {
        const imgH = el
            .querySelector(".logo_img")
            ?.getBoundingClientRect().height;
        const minH = wh - imgH - 40;
        console.log(wh, imgH, minH);
        el.querySelector(".slide_content")?.style.setProperty(
            "min-height",
            `${minH}px`
        );
    });
    const preLoader = document.querySelector(".pre_loader");
    await new Promise((resolve) => setTimeout(resolve, 1000));
    preLoader.classList.add("fade_out");
    await Promise.all(preLoader.getAnimations()?.map((anim) => anim.finished));
    preLoader.remove();
};
